define('plugin/membership/collection/MembershipCollection',['require','lib/collection/FilterableCollection','plugin/membership/model/MembershipModel'],function (require) {

    var FilterableCollection = require('lib/collection/FilterableCollection');
    var MembershipModel = require('plugin/membership/model/MembershipModel');

    /**
     * Membership collection
     *
     * @class MembershipCollection
     */
    return FilterableCollection.extend({

        url: '/ext/membership/',
        model: MembershipModel

    });

});
